<template>
  <div class="report-options flex flex-column">
    <p class="card-header-divider">
      Настройки аналитики сравнения с эталонным профилем
    </p>
    <div class="report-options__body">
      <custom-select-2
        label="Группа"
        name="group_id"
        v-model="group"
        :options="groupOptions"
      ></custom-select-2>
      <custom-select-2
        label="Эталонный профиль"
        name="reference_profile_id"
        v-model="reference"
        :options="referenceOptions"
      ></custom-select-2>
    </div>
    <div
      v-if="group && reference"
      class="report-options__btn flex justify-content-center"
    >
      <button @click="requestForReport" class="btn btn-accent">
        Получить отчет
      </button>
    </div>
  </div>
</template>

<script>
import { computed, onBeforeMount, ref } from "@vue/runtime-core";
import CustomSelect2 from "../../../components/Forms/Fields/CustomSelect2.vue";
import { useStore } from "vuex";
export default {
  components: { CustomSelect2 },
  name: "reference-report-parametres",
  setup(props, context) {
    const store = useStore();
    const group = ref(null),
      reference = ref(null),
      groupOptions = ref([]),
      referenceOptions = ref([]);
    const selectedGroup = computed(() => store.state.analytics.selectedGroup),
      groups = computed(() => store.state.group.groups),
      referenceProfiles = computed(
        () => store.state.analytics.referenceProfiles
      );

    onBeforeMount(() => {
      store.dispatch("group/getGroups").then(() => {
        groupOptions.value = groups.value.map((group) => {
          return { id: group.id, text: group.name };
        });
      });
      store.dispatch("analytics/getReferenceProfiles").then(() => {
        referenceOptions.value = referenceProfiles.value.map((reference) => {
          return { id: reference.id, text: reference.title };
        });
      });
    });

    const requestForReport = () => {
      context.emit("reportRequest", {
        group_id: group.value,
        reference_profile_id: reference.value,
      });
    };

    return {
      group,
      groupOptions,
      selectedGroup,
      groups,
      requestForReport,
      reference,
      referenceOptions,
      referenceProfiles,
    };
  },
};
</script>
